import React, { Component } from 'react';
import ImgRight from './ImgRight';
import ImgLeft from './ImgLeft';
import Pagination from '../Pagination';
import './index.css';



class BlogeContentSection extends Component {
  _numberOfArticlesInPage = 5;
  constructor(props) {
    super(props);
    this.state = {
      pagination:0
    }
    this.viewArticleClickHandler = this.viewArticleClickHandler.bind(this);
    this.paginationClickHandler = this.paginationClickHandler.bind(this);
    this.getBlogeContent = this.getBlogeContent.bind(this);
  }

  viewArticleClickHandler(article){
    console.log('Article----------',article);
  }

  paginationClickHandler(e,key){
    const { pagination } = this.state;
    const { blogeContent } = this.props;
    let articles = this._numberOfArticlesInPage;
    let isThereNext = articles + (articles*pagination) < blogeContent.length;
    let isTherePrev = articles*(pagination - 1) >= 0;
    if(key==='next'){
      if(isThereNext){
        let newState = this.state.pagination + 1;
        this.setState({pagination:newState, isThereNext, isTherePrev})
      }
    }
    if(key==='prev'){
      if(isTherePrev){
        let newState = this.state.pagination - 1;
        this.setState({pagination:newState, isThereNext, isTherePrev})
      }
    }
  }

  getBlogeContent(blogeContent){
    const { pagination } = this.state;
    let articles = this._numberOfArticlesInPage;
    let res = blogeContent.slice((articles*pagination), articles + (articles*pagination));
    return res;
  }

  render() {
    const { lang, blogeContent } = this.props;
    const { pagination } = this.state;
    const _blogeContent = this.getBlogeContent(blogeContent);
    return (
      <div className='blog-sbc-component-container'>
        <div>
          {
            _blogeContent.map((item, index)=>{
              if(index%2 === 0){
                return(<ImgRight key={item.title + index} lang={lang} item={item} onViewArticleClick={this.viewArticleClickHandler} />)
              } else {
                return(<ImgLeft key={item.title + index} lang={lang} item={item} onViewArticleClick={this.viewArticleClickHandler}/>)
              }
            })
          }
        </div>
        <div>
          <Pagination 
            onClick={this.paginationClickHandler} 
            pagination={pagination} 
            numberOfArticlesInPage={this._numberOfArticlesInPage}
            blogeContent={blogeContent}
            lang={lang}
          />
        </div>
      </div>
    );
  }
}



export default BlogeContentSection;
